import { createFileRoute } from '@tanstack/react-router';
import { Box, Container, Grid, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useCallback, useState } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { managerDocument } from '@social-garden/api/documents/manager.ts';
import { Navigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import PageTitle from '@/components/PageTitle.tsx';
import AdminCreatorsTab from '@/components/Admin/AdminCreatorsTab.tsx';
import AdminManagersTab from '@/components/Admin/AdminManagersTab.tsx';
import AdminDiscontinueCreatorHasCampaignTab from '@/components/Admin/AdminDiscontinueCreatorHasCampaignTab.tsx';

export const Route = createFileRoute('/_manager/admin')({
  component: Admin,
});

function Admin() {
  const { t } = useTranslation(['manager']);
  const [value, setValue] = useState<number>(0);
  const {
    data: { whoAmI },
  } = useSuspenseQuery(managerDocument);

  const handleOnChange = useCallback((_: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  }, []);

  if (whoAmI.__typename !== 'ManagerAuthenticatable') {
    throw new Error('Authenticated user is not a manager!');
  }

  if (!whoAmI.isAdmin) {
    return <Navigate to="/" />;
  }

  return (
    <Container maxWidth="xl">
      <Grid container spacing={4}>
        <Grid size={12}>
          <PageTitle>{t('manager:navigation.admin')}</PageTitle>
        </Grid>
        <Grid size={12}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleOnChange}>
              <Tab label="Creators" />
              <Tab label="Managers" />
              <Tab label="Discontinue creator has campaign" />
            </Tabs>
          </Box>
        </Grid>
        <Grid size={12}>
          {value === 0 ? <AdminCreatorsTab /> : null}
          {value === 1 ? <AdminManagersTab /> : null}
          {value === 2 ? <AdminDiscontinueCreatorHasCampaignTab /> : null}
        </Grid>
      </Grid>
    </Container>
  );
}
